<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="openMenuUsuario">
    <div :class="$style.dropdown">
      <!-- <a-badge :count="count"> -->
      <a-avatar shape="square" icon="user" size="large" :class="$style.avatar" />
      <!-- </a-badge> -->
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <strong>Olá, {{ nome }}</strong>
        <div><strong>Papéis: </strong> {{ papeis }}</div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div><strong class="mr-1">E-mail:</strong> {{ email }}</div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);">
          <i :class="$style.menuIcon" class="fe fe-user"></i>
          Perfil
        </a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i>
          Logout
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import Vue from "vue";
export default {
  data: function () {
    return {
      count: 7
    };
  },
  computed: {
    nome() {
      try {
        return this.$store.getters.user.fullname;
      } catch (e) {
        return "";
      }
    },
    papeis() {
      try {
        return this.$store.getters.user.role.split(",").join("|");
      } catch (e) {
        return "";
      }
    },
    email() {
      try {
        return this.$store.getters.user.email;
      } catch (e) {
        return "";
      }
    }
  },
  methods: {
    openMenuUsuario() { },
    logout() {

      var eventData = {
        nome: this.nome,
        papeis: this.papeis,
        email: this.email,
      }

      this.$store.dispatch("logout").then(() => {
        //   Vue.track("management_user_loggedOut", eventData);
        this.$router.push("/system/login");
      });
    }
  }
};
</script>

<style lang="scss" module>
@use './style.module.scss' as style;
</style>
